"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgAperture = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 13a11.125 11.125 0 011.31.078 11.008 11.008 0 018.792 6.56C34.68 20.974 35 22.45 35 24c0 2.418-.78 4.654-2.102 6.47a.894.894 0 01-.098.131 10.985 10.985 0 01-9.974 4.337.894.894 0 01-.136-.016 11.008 11.008 0 01-8.802-6.586A10.96 10.96 0 0113 24c0-2.418.78-4.654 2.102-6.47a.894.894 0 01.098-.131A10.985 10.985 0 0124 13zm4.619 12.999l-4.03 6.982a8.98 8.98 0 006.253-3.134l-2.223-3.848zM24.577 29l-8.06.001a9.005 9.005 0 005.838 3.849L24.577 29zm7.911-8h-4.446l4.031 6.982c.594-1.2.927-2.552.927-3.982 0-1.052-.18-2.061-.512-3zM27.465 24L25.733 21h-3.467l-1.732 2.999L22.267 27h3.465l1.733-3.001zM15 24c0 1.052.18 2.062.512 3h4.446l-4.031-6.982A8.963 8.963 0 0015 24zm2.158-5.847L19.38 22l4.031-6.981a8.98 8.98 0 00-6.253 3.134zm8.487-3.003L23.42 19h8.063a9.005 9.005 0 00-5.84-3.85z",
    id: "aperture_svg__a"
  }));
};

var _default = SvgAperture;
exports.default = _default;